import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../../styles/auth/auth.css";
import { useState } from "react";

const PasswordInput = (props = {}) => {
  const { password, setPassword, loading, verifying, resending } = props;
  const [showPassword, setShowPassword] = useState(false);

  return (
    <label className="label-row">
      <div>
        Your Password <p className="red-text">*</p>
      </div>
      <div className="password-input-container">
        <input
          type={showPassword ? "text" : "password"}
          placeholder="abc@1234"
          value={password}
          className="auth-input"
          onChange={(e) => setPassword(e.target.value)}
          disabled={loading || verifying || resending}
          required
        />
        <p className="show-icon" onClick={() => setShowPassword(!showPassword)}>
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </p>
      </div>
    </label>
  );
};

export default PasswordInput;
